import { TypeOfSelectors } from "app/pages/sales-intelligence/common-components/MultiSelector/types";
import trackingService from "app/pages/sales-intelligence/services/tracking/createMultiSelectorPanelService";

import RemoveFromListButton, {
    type RemoveFromListButtonProps,
} from "../../components/table-actions-panel/RemoveFromListButton/RemoveFromListButton";

const RemoveFromListButtonTracked = (props: RemoveFromListButtonProps) => {
    const handleClick = () => {
        trackingService.trackMultiSelectorOpen(TypeOfSelectors.DELETE);
        props.onClick();
    };

    return (
        <RemoveFromListButton
            {...props}
            onClick={handleClick}
        />
    );
};

export default RemoveFromListButtonTracked;
